import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";

import { formatDate } from "../dashboardHelpers";
import RowShell from "./RowShell";

function TermRow({ term }) {
  return (
    <RowShell>
      <Box flex={1} minWidth={0}>
        <Typography variant="subtitle2" noWrap>
          {term.name}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {formatDate(term.startDate)} — {formatDate(term.endDate)}
        </Typography>
      </Box>
      <Chip size="small" label={term.status} />
    </RowShell>
  );
}

export default TermRow;
